import { apiGet } from '@/services/api';
import type { ResolvedContent } from '@/features/publicsite/types/content/ResolvedContent';

/** `/stiri/{slug}` — NEWS wins over ARTICLE on a slug collision, as the server route does. */
export const newsEndpoint = (slug: string) => `/api/v1/public/news/${encodeURIComponent(slug)}`;

/** `/pagini/{slug}` — CMS pages. */
export const pageEndpoint = (slug: string) => `/api/v1/public/pages/${encodeURIComponent(slug)}`;

/**
 * `/politici/{slug}` — the three site policies, which are their own content type.
 *
 * Separate from `pageEndpoint` because the server matches the content type exactly. This route
 * was pointed at the page endpoint during the move off Thymeleaf, and since a policy is never a
 * PAGE, all three policy URLs answered 404 — including the "Politica de confidențialitate" link
 * in the footer of every public page.
 */
export const policyEndpoint = (slug: string) =>
  `/api/v1/public/policies/${encodeURIComponent(slug)}`;

/** The request ContentPage makes — through whichever of the three endpoints its route handed in. */
export const publicContentApi = {
  resolve: (endpoint: (slug: string) => string, slug: string) =>
    apiGet<ResolvedContent>(endpoint(slug)),
};
